import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { ArchiveDocumentInstanceMutation } from '@/gql/graphql';

const ArchiveDocumentInstance = graphql(`
  mutation ArchiveDocumentInstance($input: ArchiveDocumentInstanceInput!) {
    archiveDocumentInstance(input: $input)
  }
`);

const useArchiveDocumentInstance = (
  options: UseMutationOptions<
    ArchiveDocumentInstanceMutation,
    unknown,
    { projectId: string; documentInstanceId: string }
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: (input) => {
      return gqlClient.request(ArchiveDocumentInstance, {
        input: { id: input.documentInstanceId },
      });
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({
        queryKey: projectKeys.folderEntries(variables.projectId),
      });

      await options.onSuccess?.(data, variables, context);
    },
  });
};

export default useArchiveDocumentInstance;
